import React, { useState } from 'react';
import apiClient from '../services/apiClient';

// A more realistic and user-friendly component for mobile recharge.
const MobileRecharge = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [amount, setAmount] = useState('');
  const [operatorCode, setOperatorCode] = useState(''); // State for the selected operator code
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Operator list based on common API provider codes.
  // You can expand this list based on the a1topup.com documentation.
  const operators = [
    { name: 'Airtel', code: 'AT' },
    { name: 'Jio', code: 'JIO' },
    { name: 'Vi (Vodafone Idea)', code: 'VIL' },
    { name: 'BSNL', code: 'BSNL' },
  ];

  const handleRecharge = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!mobileNumber || !amount || !operatorCode) {
      setError('Please fill in all fields and select an operator.');
      return;
    }
    if (!/^\d{10}$/.test(mobileNumber)) {
      setError('Please enter a valid 10-digit mobile number.');
      return;
    }

    setIsSubmitting(true);
    try {
      // The UI only calls our own backend.
      // The backend will then securely call the a1topup.com API.
      const response = await apiClient.post('/api/recharge', {
        mobileNumber,
        amount: parseInt(amount, 10),
        operatorCode,
      });

      if (response.data && response.data.success) {
        setSuccess(response.data.message || 'Recharge submitted successfully!');
        // Clear form on success
        setMobileNumber('');
        setAmount('');
        setOperatorCode('');
      } else {
        setError(response.data.message || 'Recharge failed. Please try again.');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'An error occurred. Please check the connection.';
      setError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: '500px', margin: '40px auto', padding: '30px', background: '#f9f9f9', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <h1 style={{ textAlign: 'center', color: '#333', marginBottom: '30px' }}>Mobile Recharge</h1>
      <form onSubmit={handleRecharge}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', color: '#555' }}>Mobile Number</label>
          <input
            type="tel"
            placeholder="10-digit mobile number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ''))}
            maxLength="10"
            style={{ padding: '12px', width: '100%', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', color: '#555' }}>Operator</label>
          <select
            value={operatorCode}
            onChange={(e) => setOperatorCode(e.target.value)}
            style={{ padding: '12px', width: '100%', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', background: 'white' }}
          >
            <option value="" disabled>-- Select an Operator --</option>
            {operators.map(op => (
              <option key={op.code} value={op.code}>{op.name}</option>
            ))}
          </select>
        </div>
        <div style={{ marginBottom: '25px' }}>
          <label style={{ display: 'block', marginBottom: '5px', color: '#555' }}>Amount</label>
          <input
            type="number"
            placeholder="Recharge amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            min="10"
            style={{ padding: '12px', width: '100%', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
          />
        </div>

        {error && <p style={{ color: '#D32F2F', textAlign: 'center', marginBottom: '15px' }}>{error}</p>}
        {success && <p style={{ color: '#388E3C', textAlign: 'center', marginBottom: '15px' }}>{success}</p>}

        <button type="submit" disabled={isSubmitting} style={{ padding: '14px 20px', width: '100%', borderRadius: '6px', border: 'none', background: isSubmitting ? '#9E9E9E' : '#2196F3', color: 'white', fontSize: '16px', cursor: 'pointer' }}>
          {isSubmitting ? 'Processing...' : 'Recharge Now'}
        </button>
      </form>
    </div>
  );
};

export default MobileRecharge;